// Centralized API config driven by environment variables.
// These values are injected at build time for the frontend.
// No hardcoded production URLs in source code.

// Get API base URL from env, with fallback to Firebase Functions URL
const getApiBaseUrlFromEnv = () => {
  // Runtime check: if we're on production domain, always use production API
  const isProductionDomain = typeof window !== 'undefined' && 
    (window.location.hostname === 'digitaldivotgolf.com' || 
     window.location.hostname === 'www.digitaldivotgolf.com' ||
     window.location.hostname === 'digital-divot.web.app' ||
     window.location.hostname === 'digital-divot.firebaseapp.com');
  
  // If on production domain, force production API URL
  if (isProductionDomain && process.env.REACT_APP_FIREBASE_PROJECT_ID) {
    return `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api`;
  }
  
  // If explicitly set, use it (unless we're on production domain)
  if (process.env.REACT_APP_API_BASE_URL && !isProductionDomain) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Fallback: construct from project ID (for production builds)
  if (process.env.REACT_APP_FIREBASE_PROJECT_ID) {
    // In development, check if we're using emulator
    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
      return `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1/api`;
    }
    // Production: use deployed function URL
    return `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api`;
  }
  
  // Last resort: empty string (will cause errors, but better than undefined)
  console.warn('⚠️ REACT_APP_API_BASE_URL and REACT_APP_FIREBASE_PROJECT_ID are both missing. API calls will fail.');
  return '';
};

const API_BASE_URL = getApiBaseUrlFromEnv();

// Default to Firebase Functions API endpoint if not set
const PAYMENT_ENDPOINT = process.env.REACT_APP_PAYMENT_ENDPOINT || 
  (process.env.REACT_APP_FIREBASE_PROJECT_ID 
    ? `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api/payments/create-payment-intent`
    : '');

export const getApiBaseUrl = () => {
  const url = API_BASE_URL;
  if (!url) {
    console.error('❌ API_BASE_URL is empty. Check your .env files.');
  }
  return url;
};

export const getPaymentEndpoint = () => PAYMENT_ENDPOINT;

// Optional helper for debugging / UI badges etc.
export const ENV_INFO = {
  nodeEnv: process.env.NODE_ENV,
  apiBaseUrl: API_BASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  useEmulator: process.env.REACT_APP_USE_EMULATOR,
};
